<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="pb-16">
    <div class="px-4 pt-4">
      <user-info
        v-if="dynamicUser"
        :publish-time="dynamicContent?.publishTime || 0"
        :user="dynamicUser"
        :extinfo="extinfo"
      ></user-info>
      <div
        v-if="dynamicContent?.title"
        class="color-[#333] text-justify font-semibold leading-relaxed"
      >
        {{ dynamicContent.title }}
      </div>
      <div class="mt-2 whitespace-pre-wrap text-justify leading-relaxed">
        <span class="text-[#83C4EA]" v-html="subjectsText"></span>
        <span class="break-all text-[#333]">{{ textContent }}</span>
      </div>
      <div v-if="dynamicImages?.length === 1" class="grid grid-cols-1">
        <div
          v-for="(item, index) in dynamicImages"
          ref="dynamicImagesRef"
          :key="item.uuid"
          class="mt-2"
        >
          <img
            :src="item.url"
            :alt="item.filename"
            class="w-full rounded-lg"
            @click="toPreviewImage(index)"
          />
        </div>
      </div>
      <div
        v-else-if="dynamicImages?.length > 1"
        class="mt-2 grid grid-cols-3 gap-2 sm:gap-3"
      >
        <div
          v-for="(item, index) in dynamicImages"
          :key="item.uuid"
          class="image-box relative"
        >
          <img
            :src="item.url_s || item.url"
            :alt="item.filename"
            class="absolute top-0 h-full w-full rounded-lg object-cover"
            @click="toPreviewImage(index)"
          />
        </div>
      </div>
      <div v-if="dynamicVideos?.length >= 1" class="mt-2 grid grid-cols-1 gap-2">
        <video-player
          v-for="item in dynamicVideos"
          :key="item.uuid"
          :src="item.url"
          :poster="item.firstFrameUrl"
          :alt="item.filename"
        ></video-player>
      </div>
      <open-app-btn :extinfo="extinfo">
        <component :is="'style'"
          >.subject-text { margin-top: 10px; text-align: justify; color: #83C4EA
          }</component
        >
        <div class="subject-text" v-html="subjectsText"></div>
      </open-app-btn>
      <div
        v-if="dynamicContent?.address"
        class="mt-5 flex w-full items-center bg-[#f0f0f0] px-2.5 py-1 text-sm text-[#999]"
      >
        <img class="h-4" src="@/assets/images/location.png" />
        {{ dynamicContent?.address || 'ssssss' }}
      </div>
      <div class="mt-4 text-justify text-xs leading-relaxed text-[#999]">
        本文为Fun享+用户上传发布，仅代表用户观点，用户对发布内容负责，广州日报新花城客户端仅提供信息发布平台。
      </div>
    </div>
    <comment-list />
    <comment-operate
      v-if="!browerVersion().myApp"
      :extinfo="extinfo"
      :like-num="dynamicContent?.likeCount || 0"
    ></comment-operate>
  </section>
</template>

<script setup lang="ts">
import { browerVersion, previewImage } from '@/utils';

defineOptions({ name: 'ImageDetail' });

const dynamicUser = inject<Ref<Dynamic.DynamicUser>>('dynamicUser');
const dynamicImages = inject<Ref<Dynamic.DynamicImage[]>>('dynamicImages', ref([]));
const dynamicVideos = inject<Ref<Dynamic.DynamicVideo[]>>('dynamicVideos', ref([]));
const dynamicContent = inject<Dynamic.DynamicContentProps>('dynamicContent');
const dynamicSubjects = inject<Ref<Dynamic.DynamicSubject[]>>('dynamicSubjects', ref([]));

const extinfo = inject<Ref<string>>('extinfo', ref(''));

const textContent = computed(() => {
  let content = dynamicContent?.content || '';
  if (dynamicSubjects && dynamicSubjects.value) {
    dynamicSubjects.value.forEach((item) => {
      content = content.replace(item.displayName, '');
    });
  }
  return content;
});

const subjectsText = computed(() => {
  if (!dynamicSubjects.value) {
    return '';
  }
  return dynamicSubjects.value
    .map(
      (item) =>
        `<a class="subject-link" href="${import.meta.env.VITE_PROJECT_HTML_PATH}/media-subject.html?subjectId=${item.uuid}" target="_blank">${item.displayName}</a>`,
    )
    .join('');
});

const toPreviewImage = (index: number) => {
  const images = dynamicImages.value.map((item) => item.url);
  previewImage(images, index);
};
</script>

<style lang="scss" scoped>
.image-box {
  padding-top: 100%;
}

:deep(.subject-link) {
  @apply mr-2;
}
</style>
